import * as XLSX from "xlsx";

const defaultOptions = {};

export class DataExporter {
  /** @type {{}} **/
  options = undefined;

  /** @type {XLSX.WorkBook} **/
  workBook = undefined;
  constructor(options = {}) {
    this.options = { ...defaultOptions, ...options };
  }

  loadData(data) {
    this.workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(this.workBook, XLSX.utils.json_to_sheet(data));

    return this;
  }

  downloadXls(name = undefined) {
    this.startDownload((name ?? "export") + ".xls");
  }

  downloadXlsx(name = undefined) {
    this.startDownload((name ?? "export") + ".xlsx");
  }

  downloadCsv(name = undefined) {
    this.startDownload((name ?? "export") + ".csv", {
      FS: ";",
      forceQuotes: true
    });
  }

  startDownload(filename = undefined, options = {}) {
    if (filename === undefined) {
      this.downloadCsv("export");
    }

    XLSX.writeFile(this.workBook, filename, { ...this.options, ...options });
  }
}
